export default __webpack_public_path__ + "static/media/emailsignupmobile.a3a636fc.png";